import * as React from 'react';
import { Dialog, IconButton, DialogContent, AppBar, Toolbar, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { graphql, useStaticQuery } from 'gatsby';
import FilterSortFields from './FilterSortFields';
import { LocationLanguageContext } from '../contexts/LocationLanguageContext';
import { LocationLanguageContextType, FilterSortDialogMobileProps } from '../typings';
import { Languages } from '../utils/getAllSupportedLanguages';
import useStyles from '../styles/componentStyle';

const FilterSortDialogMobile: React.FC<FilterSortDialogMobileProps> = ({
  isBrowsePage,
  open,
  filterSortObj,
  onDialogClose,
  languages,
  categories,
  trades,
  locationState
}) => {
  const data = useStaticQuery(
    graphql`
      query FilterSortMobileQuery {
        allStrapiFilterSort {
          nodes {
            ClearAllLabel
            ApplyLabel
            locale
          }
        }
      }
    `
  );

  const locationLanguage = React.useContext<LocationLanguageContextType | null>(LocationLanguageContext);
  const language: string = locationLanguage?.language ?? Languages.English;

  const filterSortContent = data.allStrapiFilterSort.nodes.find((x: any) => x.locale === language);
  const classes = useStyles();
  const [filterSortValue, setFilterSortValue] = React.useState(filterSortObj);
  const [buttonDisabled, setButtonDisabled] = React.useState(false);

  const handleClose = () => {
    onDialogClose();
  };
  const applyFilterAndSort = () => {
    onDialogClose(filterSortValue);
  };
  const clearFilters = () => {
    const updatedFilterSortObj = {
      filters: {
        language: [],
        categories: [],
        trades: []
      },
      sort: filterSortObj.sort
    };
    setFilterSortValue(updatedFilterSortObj);
    onDialogClose(updatedFilterSortObj);
  };
  const handleFilterSortChange = (filterValue: any) => {
    setFilterSortValue(filterValue);
  };

  React.useEffect(() => {
    const isEmptyFilter = Object.values(filterSortValue.filters).every((filters) => !filters.length);
    if (isEmptyFilter) setButtonDisabled(true);
    return () => {
      setButtonDisabled(false);
    };
  }, [filterSortValue.filters]);

  return (
    <Dialog fullScreen onClose={handleClose} aria-labelledby='Filter Sort Dialog' open={open}>
      <DialogContent>
        <div>
          <div className={classes.filterTitleOnMobile}>
            <IconButton aria-label='close' onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <FilterSortFields
          filterSortObj={filterSortValue}
          onFilterSortChange={handleFilterSortChange}
          isBrowsePage={isBrowsePage}
          isMobile
          languages={languages}
          categories={categories}
          trades={trades}
          locationState={locationState}
        />
      </DialogContent>
      <AppBar position='sticky' color='primary' className={classes.filterAppBar}>
        {filterSortContent ? (
          <Toolbar className={classes.filterToolBar} data-testid='filter-toolbar'>
            <Button onClick={clearFilters} disabled={buttonDisabled}>
              {filterSortContent.ClearAllLabel}
            </Button>
            <Button color='primary' onClick={applyFilterAndSort} disabled={buttonDisabled}>
              {filterSortContent.ApplyLabel}
            </Button>
          </Toolbar>
        ) : null}
      </AppBar>
    </Dialog>
  );
};

export default FilterSortDialogMobile;
